import styled from "@emotion/styled";

export const Container = styled.div`
  height: 100%;
`;

// Clients container
export const ClientsContainer = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  grid-auto-rows: 172px;
`;

export const LeadContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  margin-bottom: 3rem;
`;

export const CreateBtn = styled.button`
  padding: 0.8rem 38px;
  border: 0.5px solid #000;
  border-radius: 40px;
  background-color: transparent;
  color: #080808;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
`;

export const Lead = styled.h1``;
